<template>
    <Card :title="$t('labels.order_custom_fields_edit')">
        <MainInformationCard
            v-if="customField"
            :custom-field="customField"
            @update:custom-field="customField = $event"
        />
    </Card>
</template>
<script>
import Card from "../../../../components/new/CardComponent.vue";
import AppButton from "../../../../components/new/button/AppButton.vue";
import MainInformationCard from "./components/MainInformationCard.vue";

import { httpClient } from "../../../../services/HttpClient";
import MessageNotificator from "../../../../services/MessageNotificator";
import { event } from "jquery";

export default {
    name: 'OrderCustomFieldsEditPage',
    components: {
        Card, AppButton, MainInformationCard
    },
    data() {
        return {
            customField: null
        }
    },
    mounted() {
        this.customField = this.$store.getters['route/crmOrderCustomField']
    }
}
</script>